// import React, { useEffect } from "react";
// import HeroSection from "../components/HeroSection";
// import InfiniteScrollingBanner from "../components/InfiniteScrollingBanner";
// import api from "../api/axiosInstance";

// const Home = () => {
//   const [bannerText, setBannerText] = React.useState("");

//   useEffect(() => {
//     const fetchBanner = async () => {
//       const res = await api.get("/banners/latest");
//       setBannerText(res.data?.content || "");
//     };
//     fetchBanner();
//   }, []);

//   return (
//     <div>
//       <HeroSection />
//       <InfiniteScrollingBanner
//         text={bannerText}
//         speed={20} // seconds for one loop
//         heightClass="h-12"
//         className="border-b md:text-[30px] border-gray-800"
//       />
//     </div>
//   );
// };

// export default Home;

import React, { useEffect, useState } from "react";
import HeroSection from "../components/HeroSection";
import InfiniteScrollingBanner from "../components/InfiniteScrollingBanner";
import { Sparkles, ArrowRight, ChevronRight } from "lucide-react";
import api from "../api/axiosInstance";

const Home = () => {
  const [bannerText, setBannerText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await api.get("/banners/latest");
        setBannerText(
          res.data?.content ||
            "Experience Excellence at Rangpur Golf & Country Club"
        );
      } catch (error) {
        setBannerText("Experience Excellence at Rangpur Golf & Country Club");
      } finally {
        setLoading(false);
      }
    };
    fetchBanner();
  }, []);

  return (
    <div className="relative">
      {/* Background Decorative Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-500/5 rounded-full blur-3xl"></div>
      </div>

      <HeroSection />

      {/* Scrolling Banner */}
      <InfiniteScrollingBanner
        text={bannerText}
        speed={70}
        heightClass="h-16 md:h-20"
        loading={loading}
      />

      {/* Quick Links Section */}
      <div className="py-12 md:py-16 px-4 md:px-8 bg-gradient-to-b from-emerald-50/50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-3 mb-4">
              <Sparkles className="w-6 h-6 text-emerald-500" />
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                Quick Access
              </h2>
              <Sparkles className="w-6 h-6 text-emerald-500" />
            </div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Explore our premium facilities and services
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              href="/membership"
              className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-emerald-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Membership
              </h3>
              <p className="text-gray-600">Join our exclusive golf community</p>
            </a>

            <a
              href="/golf-course"
              className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-emerald-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Golf Course
              </h3>
              <p className="text-gray-600">
                Explore our championship 9-hole course
              </p>
            </a>

            <a
              href="/contact"
              className="group bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                  <svg
                    className="w-6 h-6 text-emerald-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 group-hover:translate-x-2 transition-all duration-300" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Contact Us
              </h3>
              <p className="text-gray-600">Get in touch with our team</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
